import React, {Component} from 'react';
import {Button, Tooltip} from 'antd';

import {Link} from 'react-router';

class StationButtonStatisticDeviceData extends Component {
  render() {
    const {station} = this.props
    const to = `/station/${station.ID}/datas`
    return (<div>
      <Link to={to}>
        <Tooltip placement="left" title="Biểu đồ dữ liệu">
          <Button type="primary" ghost="ghost" icon="line-chart"></Button>
        </Tooltip>
      </Link>
    </div>);
  }
}

export default StationButtonStatisticDeviceData;



// WEBPACK FOOTER //
// ./src/components/StationButtonStatisticDeviceData.js